module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAMAAABhTZc9AAAAM1BMVEX////////////////////////////////////////////////////////////////////lEOhHAAAAEHRSTlMAECAwQFBgcICQoLDA0ODwVOCoyAAAAPNJREFUKJF1k0sCwyAIRCeKhijo3P+0XbR+0jasHJ/oiAiMiGqdpJd84Dtyo19ZRLR2lnBjwVjiEEdu/dxg7B5vq5Vlbi/beEx1m5nlx8aadN9yROQ9SkwAkDkdxkaSH1EaALS1b+VGj56BtFLRyK46VHGg2IQgqUtFBrSpg5AswxUAZnAqJfdzAdNfuu5nF5YpUZKmedLLttxvVzDFuyRP1PWRMuHyJ5p4IDI+0FoBeP1PIxMAWa5v1N4lrn10hojM2+vnxMP9T49yVCV2D1/w5Hr1w28timC8aWWbXyAWNsEtQun0oqrW6Rm/kbSa2XVuHl7e/wtvTdGCiAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/003-facebook.png
// module id = 205
// module chunks = 4